var _defs, _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _g3, _g4, _g5, _g6, _g7, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g8, _g9, _g10, _path17, _g11, _path18, _g12, _path19, _path20, _rect, _path21, _path22, _g13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamionPl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 148.052,
    height: 78,
    viewBox: "0 0 148.052 56.827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0.014,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 0.976,
    x2: 0.5,
    y2: -0.024,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 0.027,
    x2: 0.5,
    y2: 0.964,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: 1.006,
    x2: 0.5,
    y2: -0.001,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.5,
    y1: 0.037,
    x2: 0.5,
    y2: 1.005,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.5,
    y1: 0.03,
    x2: 0.5,
    y2: 1.076,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c7b86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#7b8a96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#a7b8c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#c2d5e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cde0ee"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22118",
    "data-name": "Groupe 22118",
    transform: "translate(-661.636 -560.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22141",
    "data-name": "Groupe 22141",
    transform: "translate(662 560.999)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22119",
    "data-name": "Groupe 22119",
    transform: "translate(8.833 3.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4724",
    "data-name": "Trac\\xE9 4724",
    d: "M43.6,249.464a9.733,9.733,0,0,1,2.787-2.3c4.882-3.077,9.5-4.662,16.978-5.86a1.076,1.076,0,0,1,1.3,1.085v5.822c0,.333-.048.642-.642.642H56.395A105.228,105.228,0,0,0,43.872,250C43.534,250.06,43.4,249.736,43.6,249.464Z",
    transform: "translate(-43.509 -241.285)",
    stroke: "#ccc",
    strokeWidth: 0.729,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4725",
    "data-name": "Trac\\xE9 4725",
    d: "M46.907,249.818c.363-.251.723-.48,1.062-.671a49.265,49.265,0,0,1,16.9-5.534c.952-.153,1.285.346,1.292,1.012v-.992a1.044,1.044,0,0,0-1.263-1.055c-7.23,1.223-11.866,2.852-16.512,5.7a15.891,15.891,0,0,0-1.9,1.357C46.348,249.759,46.426,250.13,46.907,249.818Z",
    transform: "translate(-45.299 -242.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22118-2",
    "data-name": "Groupe 22118",
    transform: "translate(0.891 7.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4726",
    "data-name": "Trac\\xE9 4726",
    d: "M63.958,261.73a2.651,2.651,0,0,1,1.586.526v-1.43c-.035,0-.067.008-.106.008H57.808A106.468,106.468,0,0,0,45.814,261.9v.731c4.252-.481,9.914-.9,12.261-.9Z",
    transform: "translate(-45.814 -260.827)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22140",
    "data-name": "Groupe 22140",
    transform: "translate(0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4727",
    "data-name": "Trac\\xE9 4727",
    d: "M169.817,295.443H59.576V271.251H54.925V270.8a.344.344,0,0,0-.344-.344h-1.1a.343.343,0,0,0-.343.344v23.979a.6.6,0,0,1-.609.552h-28.7v7.858H165.036v-2.15h4.781a.476.476,0,0,0,.476-.476V295.92A.477.477,0,0,0,169.817,295.443Z",
    transform: "translate(-22.605 -255.45)",
    fill: "#1a1a1a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4728",
    "data-name": "Trac\\xE9 4728",
    d: "M399.1,341.367h-1.711a.476.476,0,0,1-.476-.476v-2.586a.476.476,0,0,1,.476-.476H399.1Z",
    transform: "translate(-251.412 -296.771)",
    fill: "#d9000d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4729",
    "data-name": "Trac\\xE9 4729",
    d: "M398,338.355a.477.477,0,0,0-.476.477v.611a.477.477,0,0,1,.476-.476h1.476v-.611Z",
    transform: "translate(-251.785 -297.094)",
    fill: "#9a0a14"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4730",
    "data-name": "Trac\\xE9 4730",
    d: "M397.52,344.392v.305a.476.476,0,0,0,.476.476h1.476v-.305H398A.477.477,0,0,1,397.52,344.392Z",
    transform: "translate(-251.785 -300.796)",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22120",
    "data-name": "Groupe 22120",
    transform: "translate(10.171 40.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4731",
    "data-name": "Trac\\xE9 4731",
    d: "M68.186,346.746v-1.378a7.91,7.91,0,1,0-15.82,0v1.378Z",
    transform: "translate(-50.279 -336.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4732",
    "data-name": "Trac\\xE9 4732",
    d: "M46.969,335.561H65.458a1.424,1.424,0,0,1,1.425,1.425v8.6a.34.34,0,0,1-.341.34H65.216a.34.34,0,0,1-.34-.34V344.2a7.91,7.91,0,1,0-15.82,0v1.378a.34.34,0,0,1-.34.34H46.969Z",
    transform: "translate(-46.969 -335.561)",
    fill: "#333"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4733",
    "data-name": "Trac\\xE9 4733",
    d: "M327.491,346.746v-1.378a7.91,7.91,0,1,0-15.82,0v1.378Z",
    transform: "translate(-199.135 -296.544)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4734",
    "data-name": "Trac\\xE9 4734",
    d: "M280.3,346.746v-1.378a7.91,7.91,0,1,0-15.82,0v1.378Z",
    transform: "translate(-170.197 -296.544)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4735",
    "data-name": "Trac\\xE9 4735",
    d: "M24.148,267.2a3.749,3.749,0,0,1,3.1-2.722,147.818,147.818,0,0,1,15.408-1.316h5.883A2.666,2.666,0,0,1,51.2,265.83v24.778a.6.6,0,0,1-.609.553H40.085a7.819,7.819,0,0,0-7.82,7.819v2.9a.553.553,0,0,1-.553.553H22.006a1.086,1.086,0,0,1-1.086-1.086V290.524a.679.679,0,0,1,.679-.679h.059a.672.672,0,0,1-.663-.538,18.186,18.186,0,0,1-.327-3.69V280.45C20.668,278.743,22.657,272.057,24.148,267.2Z",
    transform: "translate(-20.668 -250.98)",
    stroke: "#ccc",
    strokeWidth: 0.729,
    fill: "url(#linear-gradient-2)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22123",
    "data-name": "Groupe 22123",
    transform: "translate(12.631 41.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4736",
    "data-name": "Trac\\xE9 4736",
    d: "M68.362,345.993a7.516,7.516,0,1,1-7.516-7.516A7.517,7.517,0,0,1,68.362,345.993Z",
    transform: "translate(-53.33 -338.477)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22122",
    "data-name": "Groupe 22122",
    transform: "translate(1.705 0.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4737",
    "data-name": "Trac\\xE9 4737",
    d: "M70.009,350.454a4.7,4.7,0,1,1-4.7-4.7A4.7,4.7,0,0,1,70.009,350.454Z",
    transform: "translate(-59.495 -343.47)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4738",
    "data-name": "Trac\\xE9 4738",
    d: "M70.34,352.879a2.582,2.582,0,1,1-2.582-2.583A2.582,2.582,0,0,1,70.34,352.879Zm-2.582-3.156a3.156,3.156,0,1,0,3.156,3.156A3.156,3.156,0,0,0,67.758,349.723Z",
    transform: "translate(-61.948 -345.906)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4739",
    "data-name": "Trac\\xE9 4739",
    d: "M71.147,354.365a1.848,1.848,0,1,1-1.848-1.848A1.848,1.848,0,0,1,71.147,354.365ZM69.3,352.126a2.227,2.227,0,1,0,2.227,2.227A2.226,2.226,0,0,0,69.3,352.126Z",
    transform: "translate(-63.464 -347.38)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4740",
    "data-name": "Trac\\xE9 4740",
    d: "M69.312,342.9a6.976,6.976,0,0,0-5.762-3.041,6.87,6.87,0,0,0-5.753,3.03.391.391,0,0,0-.058.215.4.4,0,0,0,.73.223,6.112,6.112,0,0,1,5.087-2.664,6.2,6.2,0,0,1,5.089,2.672.4.4,0,0,0,.725-.222A.372.372,0,0,0,69.312,342.9Z",
    transform: "translate(-57.739 -339.854)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4741",
    "data-name": "Trac\\xE9 4741",
    d: "M69.625,365.747a6.343,6.343,0,0,1-5.24,2.766,6.248,6.248,0,0,1-5.232-2.755.353.353,0,0,1-.053-.2.363.363,0,0,1,.664-.2,5.558,5.558,0,0,0,4.627,2.423,5.638,5.638,0,0,0,4.627-2.43.36.36,0,0,1,.66.2A.335.335,0,0,1,69.625,365.747Z",
    transform: "translate(-58.574 -355.393)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22121",
    "data-name": "Groupe 22121",
    transform: "translate(1.697 2.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4742",
    "data-name": "Trac\\xE9 4742",
    d: "M71.069,347.47a4.049,4.049,0,0,1,.727.073c.15.027.22-.021.25-.114l.084-.312a.218.218,0,0,0-.181-.274,4.383,4.383,0,0,0-1.757,0,.218.218,0,0,0-.181.274l.084.312c.03.093.1.142.251.114a4.045,4.045,0,0,1,.727-.073Z",
    transform: "translate(-66.958 -346.754)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4743",
    "data-name": "Trac\\xE9 4743",
    d: "M63.125,351.423a4.027,4.027,0,0,1,.427-.593c.1-.116.092-.2.026-.274l-.229-.228a.218.218,0,0,0-.328.019,4.8,4.8,0,0,0-.517.716,4.738,4.738,0,0,0-.362.806.217.217,0,0,0,.147.293l.312.085c.1.02.173-.017.224-.16a4.06,4.06,0,0,1,.3-.666Z",
    transform: "translate(-62.128 -348.906)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4744",
    "data-name": "Trac\\xE9 4744",
    d: "M63.126,361.25a4.07,4.07,0,0,1-.3-.666c-.051-.143-.129-.18-.224-.159l-.312.084a.218.218,0,0,0-.147.294,4.36,4.36,0,0,0,.878,1.521.218.218,0,0,0,.328.019l.229-.229c.066-.073.072-.159-.026-.274a4.044,4.044,0,0,1-.427-.592Z",
    transform: "translate(-62.128 -355.135)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4745",
    "data-name": "Trac\\xE9 4745",
    d: "M71.073,367.088a4.015,4.015,0,0,1-.727-.073c-.15-.027-.22.021-.251.115l-.083.312a.218.218,0,0,0,.181.274,4.38,4.38,0,0,0,1.757,0,.218.218,0,0,0,.18-.274l-.083-.312c-.03-.094-.1-.142-.25-.115a4.022,4.022,0,0,1-.727.073Z",
    transform: "translate(-66.958 -359.175)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4746",
    "data-name": "Trac\\xE9 4746",
    d: "M80.03,361.247a4.039,4.039,0,0,1-.427.592c-.1.116-.092.2-.026.274l.229.229a.217.217,0,0,0,.328-.02,4.774,4.774,0,0,0,.517-.715,4.826,4.826,0,0,0,.362-.805.219.219,0,0,0-.147-.294l-.312-.083c-.1-.021-.173.016-.224.159a4.073,4.073,0,0,1-.3.666Z",
    transform: "translate(-72.799 -355.134)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4747",
    "data-name": "Trac\\xE9 4747",
    d: "M80.028,351.42a4.08,4.08,0,0,1,.3.666c.051.145.129.181.224.16l.312-.085a.217.217,0,0,0,.147-.293,4.342,4.342,0,0,0-.878-1.521.217.217,0,0,0-.328-.019l-.229.228c-.066.073-.072.159.026.274a4.026,4.026,0,0,1,.427.593Z",
    transform: "translate(-72.799 -348.905)",
    fill: "#1a1a1a"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22126",
    "data-name": "Groupe 22126",
    transform: "translate(94.745 41.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4748",
    "data-name": "Trac\\xE9 4748",
    d: "M280.7,345.993a7.516,7.516,0,1,1-7.516-7.516A7.517,7.517,0,0,1,280.7,345.993Z",
    transform: "translate(-265.665 -338.477)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22125",
    "data-name": "Groupe 22125",
    transform: "translate(1.705 0.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4749",
    "data-name": "Trac\\xE9 4749",
    d: "M282.344,350.454a4.7,4.7,0,1,1-4.7-4.7A4.7,4.7,0,0,1,282.344,350.454Z",
    transform: "translate(-271.829 -343.47)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4750",
    "data-name": "Trac\\xE9 4750",
    d: "M282.675,352.879a2.582,2.582,0,1,1-2.582-2.583A2.582,2.582,0,0,1,282.675,352.879Zm-2.582-3.156a3.156,3.156,0,1,0,3.156,3.156A3.156,3.156,0,0,0,280.092,349.723Z",
    transform: "translate(-274.282 -345.906)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4751",
    "data-name": "Trac\\xE9 4751",
    d: "M283.481,354.365a1.848,1.848,0,1,1-1.848-1.848A1.848,1.848,0,0,1,283.481,354.365Zm-1.846-2.239a2.227,2.227,0,1,0,2.227,2.227A2.227,2.227,0,0,0,281.635,352.126Z",
    transform: "translate(-275.798 -347.38)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4752",
    "data-name": "Trac\\xE9 4752",
    d: "M281.647,342.9a6.976,6.976,0,0,0-5.763-3.041,6.869,6.869,0,0,0-5.753,3.03.392.392,0,0,0-.058.215.4.4,0,0,0,.4.4.4.4,0,0,0,.33-.176,6.112,6.112,0,0,1,5.088-2.664,6.2,6.2,0,0,1,5.088,2.672.4.4,0,0,0,.726-.222A.372.372,0,0,0,281.647,342.9Z",
    transform: "translate(-270.073 -339.854)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4753",
    "data-name": "Trac\\xE9 4753",
    d: "M281.959,365.747a6.343,6.343,0,0,1-5.24,2.766,6.249,6.249,0,0,1-5.232-2.755.356.356,0,0,1-.053-.2.363.363,0,0,1,.664-.2,5.559,5.559,0,0,0,4.627,2.423,5.638,5.638,0,0,0,4.627-2.43.36.36,0,0,1,.66.2A.338.338,0,0,1,281.959,365.747Z",
    transform: "translate(-270.908 -355.393)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22124",
    "data-name": "Groupe 22124",
    transform: "translate(1.698 2.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4754",
    "data-name": "Trac\\xE9 4754",
    d: "M283.4,347.47a4.049,4.049,0,0,1,.727.073c.149.027.22-.021.25-.114l.084-.312a.218.218,0,0,0-.181-.274,4.383,4.383,0,0,0-1.757,0,.218.218,0,0,0-.181.274l.084.312c.03.093.1.142.25.114a4.049,4.049,0,0,1,.727-.073Z",
    transform: "translate(-279.292 -346.754)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4755",
    "data-name": "Trac\\xE9 4755",
    d: "M275.459,351.423a4.052,4.052,0,0,1,.427-.593c.1-.116.092-.2.026-.274l-.229-.228a.218.218,0,0,0-.328.019,4.851,4.851,0,0,0-.517.716,4.766,4.766,0,0,0-.362.806.218.218,0,0,0,.147.293l.312.085c.1.02.173-.017.225-.16a4.025,4.025,0,0,1,.3-.666Z",
    transform: "translate(-274.463 -348.906)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4756",
    "data-name": "Trac\\xE9 4756",
    d: "M275.461,361.25a4.038,4.038,0,0,1-.3-.666c-.051-.143-.129-.18-.225-.159l-.312.084a.218.218,0,0,0-.147.294,4.35,4.35,0,0,0,.878,1.521.219.219,0,0,0,.328.019l.229-.229c.066-.073.072-.159-.026-.274a4.071,4.071,0,0,1-.427-.592Z",
    transform: "translate(-274.463 -355.135)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4757",
    "data-name": "Trac\\xE9 4757",
    d: "M283.408,367.088a4.023,4.023,0,0,1-.727-.073c-.15-.027-.22.021-.25.115l-.083.312a.218.218,0,0,0,.181.274,4.38,4.38,0,0,0,1.757,0,.218.218,0,0,0,.18-.274l-.083-.312c-.03-.094-.1-.142-.25-.115a4.022,4.022,0,0,1-.727.073Z",
    transform: "translate(-279.293 -359.175)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4758",
    "data-name": "Trac\\xE9 4758",
    d: "M292.364,361.247a4.066,4.066,0,0,1-.427.592c-.1.116-.092.2-.026.274l.229.229a.217.217,0,0,0,.328-.02,4.771,4.771,0,0,0,.516-.715,4.827,4.827,0,0,0,.362-.805.219.219,0,0,0-.147-.294l-.312-.083c-.1-.021-.173.016-.224.159a4.075,4.075,0,0,1-.3.666Z",
    transform: "translate(-285.133 -355.134)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4759",
    "data-name": "Trac\\xE9 4759",
    d: "M292.363,351.42a4.073,4.073,0,0,1,.3.666c.051.145.129.181.224.16l.312-.085a.217.217,0,0,0,.147-.293,4.358,4.358,0,0,0-.878-1.521.217.217,0,0,0-.328-.019l-.229.228c-.066.073-.072.159.026.274a4.053,4.053,0,0,1,.427.593Z",
    transform: "translate(-285.134 -348.905)",
    fill: "#1a1a1a"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22129",
    "data-name": "Groupe 22129",
    transform: "translate(112.904 41.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4760",
    "data-name": "Trac\\xE9 4760",
    d: "M327.655,345.993a7.516,7.516,0,1,1-7.516-7.516A7.517,7.517,0,0,1,327.655,345.993Z",
    transform: "translate(-312.623 -338.477)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22128",
    "data-name": "Groupe 22128",
    transform: "translate(1.705 0.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4761",
    "data-name": "Trac\\xE9 4761",
    d: "M329.3,350.454a4.7,4.7,0,1,1-4.7-4.7A4.7,4.7,0,0,1,329.3,350.454Z",
    transform: "translate(-318.788 -343.47)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4762",
    "data-name": "Trac\\xE9 4762",
    d: "M329.633,352.879a2.582,2.582,0,1,1-2.582-2.583A2.582,2.582,0,0,1,329.633,352.879Zm-2.582-3.156a3.156,3.156,0,1,0,3.156,3.156A3.156,3.156,0,0,0,327.05,349.723Z",
    transform: "translate(-321.24 -345.906)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4763",
    "data-name": "Trac\\xE9 4763",
    d: "M330.439,354.365a1.848,1.848,0,1,1-1.848-1.848A1.848,1.848,0,0,1,330.439,354.365Zm-1.846-2.239a2.227,2.227,0,1,0,2.227,2.227A2.227,2.227,0,0,0,328.593,352.126Z",
    transform: "translate(-322.757 -347.38)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4764",
    "data-name": "Trac\\xE9 4764",
    d: "M328.6,342.9a6.975,6.975,0,0,0-5.762-3.041,6.87,6.87,0,0,0-5.753,3.03.391.391,0,0,0-.058.215.4.4,0,0,0,.73.223,6.111,6.111,0,0,1,5.088-2.664,6.2,6.2,0,0,1,5.088,2.672.4.4,0,0,0,.726-.222A.366.366,0,0,0,328.6,342.9Z",
    transform: "translate(-317.032 -339.854)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4765",
    "data-name": "Trac\\xE9 4765",
    d: "M328.918,365.747a6.343,6.343,0,0,1-5.24,2.766,6.248,6.248,0,0,1-5.232-2.755.353.353,0,0,1-.053-.2.363.363,0,0,1,.664-.2,5.557,5.557,0,0,0,4.627,2.423,5.639,5.639,0,0,0,4.628-2.43.36.36,0,0,1,.66.2A.335.335,0,0,1,328.918,365.747Z",
    transform: "translate(-317.867 -355.393)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22127",
    "data-name": "Groupe 22127",
    transform: "translate(1.697 2.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4766",
    "data-name": "Trac\\xE9 4766",
    d: "M330.363,347.47a4.053,4.053,0,0,1,.727.073c.149.027.22-.021.25-.114l.084-.312a.218.218,0,0,0-.181-.274,4.379,4.379,0,0,0-1.756,0,.218.218,0,0,0-.181.274l.084.312c.03.093.1.142.25.114a4.049,4.049,0,0,1,.727-.073Z",
    transform: "translate(-326.251 -346.754)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4767",
    "data-name": "Trac\\xE9 4767",
    d: "M322.418,351.423a4.031,4.031,0,0,1,.427-.593c.1-.116.092-.2.026-.274l-.229-.228a.217.217,0,0,0-.327.019,4.36,4.36,0,0,0-.879,1.521.218.218,0,0,0,.147.293l.312.085c.1.02.173-.017.224-.16a4.028,4.028,0,0,1,.3-.666Z",
    transform: "translate(-321.421 -348.906)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4768",
    "data-name": "Trac\\xE9 4768",
    d: "M322.419,361.25a4.04,4.04,0,0,1-.3-.666c-.051-.143-.129-.18-.224-.159l-.312.084a.218.218,0,0,0-.147.294,4.361,4.361,0,0,0,.878,1.521.218.218,0,0,0,.327.019l.229-.229c.066-.073.072-.159-.026-.274a4.046,4.046,0,0,1-.427-.592Z",
    transform: "translate(-321.421 -355.135)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4769",
    "data-name": "Trac\\xE9 4769",
    d: "M330.366,367.088a4.022,4.022,0,0,1-.727-.073c-.15-.027-.22.021-.25.115l-.083.312a.218.218,0,0,0,.181.274,4.378,4.378,0,0,0,1.756,0,.218.218,0,0,0,.18-.274l-.083-.312c-.03-.094-.1-.142-.25-.115a4.029,4.029,0,0,1-.727.073Z",
    transform: "translate(-326.251 -359.175)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4770",
    "data-name": "Trac\\xE9 4770",
    d: "M339.322,361.247a4.007,4.007,0,0,1-.427.592c-.1.116-.092.2-.026.274l.229.229a.217.217,0,0,0,.327-.02,4.776,4.776,0,0,0,.517-.715,4.827,4.827,0,0,0,.362-.805.218.218,0,0,0-.147-.294l-.312-.083c-.1-.021-.174.016-.224.159a4.042,4.042,0,0,1-.3.666Z",
    transform: "translate(-332.092 -355.134)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4771",
    "data-name": "Trac\\xE9 4771",
    d: "M339.321,351.42a4.049,4.049,0,0,1,.3.666c.051.145.129.181.224.16l.312-.085a.217.217,0,0,0,.147-.293,4.341,4.341,0,0,0-.878-1.521.217.217,0,0,0-.327-.019l-.229.228c-.066.073-.072.159.026.274a4,4,0,0,1,.427.593Z",
    transform: "translate(-332.092 -348.905)",
    fill: "#1a1a1a"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22130",
    "data-name": "Groupe 22130",
    transform: "translate(32.969 42.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2469",
    "data-name": "Rectangle 2469",
    d: "M2.754,0H55.12a2.754,2.754,0,0,1,2.754,2.754v5.2a2.755,2.755,0,0,1-2.755,2.755H2.755A2.755,2.755,0,0,1,0,7.956v-5.2A2.754,2.754,0,0,1,2.754,0Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4772",
    "data-name": "Trac\\xE9 4772",
    d: "M163.038,364.23H107.619a.891.891,0,0,1-.891-.891v.838a.891.891,0,0,0,.891.891h55.419a.891.891,0,0,0,.891-.891v-.838A.891.891,0,0,1,163.038,364.23Z",
    transform: "translate(-106.416 -354.703)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4773",
    "data-name": "Trac\\xE9 4773",
    d: "M163.038,342.938H107.619a.891.891,0,0,0-.891.891v-.838a.89.89,0,0,1,.891-.89h55.419a.891.891,0,0,1,.891.89v.838A.891.891,0,0,0,163.038,342.938Z",
    transform: "translate(-106.416 -341.678)",
    fill: "#666"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22131",
    "data-name": "Groupe 22131",
    transform: "translate(131.18 41.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2470",
    "data-name": "Rectangle 2470",
    d: "M2.755,0H9.123a2.754,2.754,0,0,1,2.754,2.754v3.63A2.755,2.755,0,0,1,9.122,9.138H2.755A2.755,2.755,0,0,1,0,6.384V2.755A2.755,2.755,0,0,1,2.755,0Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4774",
    "data-name": "Trac\\xE9 4774",
    d: "M371,358.22h-9.422a.891.891,0,0,1-.891-.891v.838a.891.891,0,0,0,.891.891H371a.892.892,0,0,0,.891-.891v-.838A.891.891,0,0,1,371,358.22Z",
    transform: "translate(-360.375 -350.265)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4775",
    "data-name": "Trac\\xE9 4775",
    d: "M371,340.994h-9.422a.891.891,0,0,0-.891.891v-.838a.89.89,0,0,1,.891-.891H371a.891.891,0,0,1,.891.891v.838A.891.891,0,0,0,371,340.994Z",
    transform: "translate(-360.375 -339.734)",
    fill: "#666"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4776",
    "data-name": "Trac\\xE9 4776",
    d: "M137.627,335.075v11.579a.447.447,0,0,1-.447.447h-1.353a.447.447,0,0,1-.447-.447V335.075Z",
    transform: "translate(-91.019 -295.082)",
    fill: "#1a1a1a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4777",
    "data-name": "Trac\\xE9 4777",
    d: "M223.63,335.075v11.579a.447.447,0,0,1-.447.447h-1.353a.447.447,0,0,1-.447-.447V335.075Z",
    transform: "translate(-143.763 -295.082)",
    fill: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4778",
    "data-name": "Trac\\xE9 4778",
    d: "M32.312,360.022H22.98a.918.918,0,0,1-.918-.918v.864a.919.919,0,0,0,.918.918l9.293,0c.507,0,.722-.2.722-.634V359.1C32.962,359.818,32.819,360.022,32.312,360.022Z",
    transform: "translate(-21.523 -309.819)",
    fill: "#999",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4779",
    "data-name": "Trac\\xE9 4779",
    d: "M21.883,334.055c0-.8.235-1.217.7-1.217h15.8a.3.3,0,1,1,0,.607H23.1C22.573,333.445,22.106,333.433,21.883,334.055Z",
    transform: "translate(-21.413 -293.71)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4780",
    "data-name": "Trac\\xE9 4780",
    d: "M31.216,268.382a3.709,3.709,0,0,1,2.863-1.776c3.863-.537,12.054-1.068,14.993-1.068h5.751a2.349,2.349,0,0,1,2.376,1.529,2.561,2.561,0,0,0-2.561-2.562h-5.65a142.017,142.017,0,0,0-14.8,1.264A3.6,3.6,0,0,0,31.216,268.382Z",
    transform: "translate(-27.137 -251.803)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2471",
    "data-name": "Rectangle 2471",
    d: "M1.123,0H58.308a1.123,1.123,0,0,1,1.123,1.123v0a1.122,1.122,0,0,1-1.122,1.122H1.123A1.123,1.123,0,0,1,0,1.123v0A1.123,1.123,0,0,1,1.123,0Z",
    transform: "translate(32.437 44.323)",
    fill: "#1a1a1a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2472",
    "data-name": "Rectangle 2472",
    d: "M1.123,0H58.307a1.123,1.123,0,0,1,1.123,1.123v0a1.123,1.123,0,0,1-1.123,1.123H1.123A1.123,1.123,0,0,1,0,1.123v0A1.123,1.123,0,0,1,1.123,0Z",
    transform: "translate(32.437 48.143)",
    fill: "#1a1a1a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4781",
    "data-name": "Trac\\xE9 4781",
    d: "M163.639,356.409H105.206a.4.4,0,0,0-.4.4v.111a.4.4,0,0,1,.4-.4h58.433a.4.4,0,0,1,.4.4v-.111A.4.4,0,0,0,163.639,356.409Z",
    transform: "translate(-72.271 -308.166)",
    fill: "#666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4782",
    "data-name": "Trac\\xE9 4782",
    d: "M163.639,360.766H105.206a.4.4,0,0,1-.4-.4v.111a.4.4,0,0,0,.4.4h58.433a.4.4,0,0,0,.4-.4v-.111A.4.4,0,0,1,163.639,360.766Z",
    transform: "translate(-72.271 -310.595)",
    fill: "#161615"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4783",
    "data-name": "Trac\\xE9 4783",
    d: "M163.639,346.606H105.206a.4.4,0,0,0-.4.4v.111a.4.4,0,0,1,.4-.4h58.433a.4.4,0,0,1,.4.4V347A.4.4,0,0,0,163.639,346.606Z",
    transform: "translate(-72.271 -302.154)",
    fill: "#666"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4784",
    "data-name": "Trac\\xE9 4784",
    d: "M163.639,350.963H105.206a.4.4,0,0,1-.4-.4v.111a.4.4,0,0,0,.4.4h58.433a.4.4,0,0,0,.4-.4v-.111A.4.4,0,0,1,163.639,350.963Z",
    transform: "translate(-72.271 -304.583)",
    fill: "#161615"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22132",
    "data-name": "Groupe 22132",
    transform: "translate(44.362 39.993)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2473",
    "data-name": "Rectangle 2473",
    width: 2.246,
    height: 1.409
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2474",
    "data-name": "Rectangle 2474",
    width: 2.246,
    height: 0.446,
    transform: "translate(0 6.576)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2475",
    "data-name": "Rectangle 2475",
    width: 2.246,
    height: 0.446,
    transform: "translate(0 10.397)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22133",
    "data-name": "Groupe 22133",
    transform: "translate(77.62 39.993)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2476",
    "data-name": "Rectangle 2476",
    width: 2.246,
    height: 1.409
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2477",
    "data-name": "Rectangle 2477",
    width: 2.246,
    height: 0.446,
    transform: "translate(0 6.576)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2478",
    "data-name": "Rectangle 2478",
    width: 2.246,
    height: 0.446,
    transform: "translate(0 10.397)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22135",
    "data-name": "Groupe 22135",
    transform: "translate(33.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2479",
    "data-name": "Rectangle 2479",
    d: "M5.509,0h102.82a5.51,5.51,0,0,1,5.51,5.51V34.484a5.509,5.509,0,0,1-5.509,5.509H5.509A5.509,5.509,0,0,1,0,34.484V5.509A5.509,5.509,0,0,1,5.509,0Z",
    stroke: "#ccc",
    strokeWidth: 0.972,
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22134",
    "data-name": "Groupe 22134",
    transform: "translate(0.698 0.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4785",
    "data-name": "Trac\\xE9 4785",
    d: "M218.9,233.4H109.977a1.745,1.745,0,0,0-1.745,1.745v1.08a1.745,1.745,0,0,1,1.745-1.745H218.9a1.745,1.745,0,0,1,1.745,1.745v-1.08A1.745,1.745,0,0,0,218.9,233.4Z",
    transform: "translate(-108.232 -233.402)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4786",
    "data-name": "Trac\\xE9 4786",
    d: "M218.9,327.327H109.977a1.746,1.746,0,0,1-1.745-1.746v1.081a1.745,1.745,0,0,0,1.745,1.745H218.9a1.745,1.745,0,0,0,1.745-1.745v-1.081A1.745,1.745,0,0,1,218.9,327.327Z",
    transform: "translate(-108.232 -289.934)",
    fill: "#b3b3b3"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_57",
    "data-name": "Ligne 57",
    y2: 12.241,
    transform: "translate(15.658 26.269)",
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.486,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2480",
    "data-name": "Rectangle 2480",
    d: "M1.651,0H5.438A1.652,1.652,0,0,1,7.09,1.652V3.589A1.653,1.653,0,0,1,5.437,5.242H1.652A1.652,1.652,0,0,1,0,3.59V1.651A1.651,1.651,0,0,1,1.651,0Z",
    transform: "translate(3.245 44.365)",
    fill: "#333"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22137",
    "data-name": "Groupe 22137",
    transform: "translate(3.245 44.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4787",
    "data-name": "Trac\\xE9 4787",
    d: "M35.509,346.38H29.7a.639.639,0,0,0-.639.639v.908a.639.639,0,0,1,.639-.639h5.812a.639.639,0,0,1,.639.639v-.908A.639.639,0,0,0,35.509,346.38Z",
    transform: "translate(-29.058 -346.38)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22136",
    "data-name": "Groupe 22136",
    transform: "translate(0 4.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4788",
    "data-name": "Trac\\xE9 4788",
    d: "M35.509,357.87H29.7a.639.639,0,0,1-.639-.639v.407a.639.639,0,0,0,.639.639h5.812a.639.639,0,0,0,.639-.639v-.407A.639.639,0,0,1,35.509,357.87Z",
    transform: "translate(-29.058 -357.231)",
    fill: "#4d4d4d"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4789",
    "data-name": "Trac\\xE9 4789",
    d: "M34.549,291.174l1.48-5.1a1.021,1.021,0,0,1,.981-.785l8.314.006a1.357,1.357,0,0,0,1.357-1.357v-6.3a1.357,1.357,0,0,0-1.357-1.357H31.034a1.319,1.319,0,0,0-1.273.885c-.546,1.754-1.847,7.253-2.012,8.416-.024.167-.035.529-.035.611v4.487a1.483,1.483,0,0,0,1.376,1.4h3.93A1.585,1.585,0,0,0,34.549,291.174Z",
    transform: "translate(-24.989 -259.026)",
    fill: "url(#linear-gradient-19)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22138",
    "data-name": "Groupe 22138",
    transform: "translate(3.49 45.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4790",
    "data-name": "Trac\\xE9 4790",
    d: "M29.987,350.719a.3.3,0,0,1,0-.591H35.97a.3.3,0,0,1,0,.591Z",
    transform: "translate(-29.692 -350.128)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4791",
    "data-name": "Trac\\xE9 4791",
    d: "M29.987,353.791a.3.3,0,1,1,0-.591H35.97a.3.3,0,1,1,0,.591Z",
    transform: "translate(-29.692 -352.012)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4792",
    "data-name": "Trac\\xE9 4792",
    d: "M29.987,356.862a.3.3,0,0,1,0-.592H35.97a.3.3,0,0,1,0,.592Z",
    transform: "translate(-29.692 -353.895)",
    fill: "#1a1a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22139",
    "data-name": "Groupe 22139",
    transform: "translate(2.725 19.01)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4793",
    "data-name": "Trac\\xE9 4793",
    d: "M28.13,286.467c-.191.864-.334,1.562-.381,1.9-.024.167-.035.529-.035.611v4.487a1.483,1.483,0,0,0,1.376,1.4H30.25v-1.239l2.443-3.523-1.942-4.149Zm17.651-5.212-1.25,4.291H42.778l-.5-3.014a.5.5,0,0,0-.428-.391H40.272c-.485,0-1.2,2.173-.877,2.685-.485.313-.657.57-.971,1.425l-.752,1.822,7.652.006a1.357,1.357,0,0,0,1.357-1.357v-5.905h-.32A.8.8,0,0,0,45.781,281.255Z",
    transform: "translate(-27.714 -280.817)",
    fill: "#b3b3b3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4794",
    "data-name": "Trac\\xE9 4794",
    d: "M40.545,296.693,36.751,293.1a.37.37,0,1,0-.509.537l1.343,1.272-1.872,1.978,1.01.956,1.872-1.978,1.441,1.364a.37.37,0,1,0,.509-.537Z",
    transform: "translate(-32.62 -288.288)",
    fill: "#b3b3b3"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2481",
    "data-name": "Rectangle 2481",
    width: 2.49,
    height: 8.972,
    transform: "translate(14.234 17.257)",
    fill: "#1a1a1a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4795",
    "data-name": "Trac\\xE9 4795",
    d: "M34.549,291.174l1.48-5.1a1.021,1.021,0,0,1,.981-.785l8.314.006a1.357,1.357,0,0,0,1.357-1.357v-6.3a1.357,1.357,0,0,0-1.357-1.357H31.034a1.319,1.319,0,0,0-1.273.885c-.546,1.754-1.847,7.253-2.012,8.416-.024.167-.035.529-.035.611v4.487a1.483,1.483,0,0,0,1.376,1.4h3.93A1.585,1.585,0,0,0,34.549,291.174Z",
    transform: "translate(-24.989 -259.026)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeWidth: 0.972
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4796",
    "data-name": "Trac\\xE9 4796",
    d: "M296.21,335.561a1.424,1.424,0,0,1,1.425,1.425v8.6a.34.34,0,0,1-.34.34h-.885a.34.34,0,0,1-.34-.34V344.2a7.91,7.91,0,1,0-15.82,0v1.378a.34.34,0,0,1-.341.34h-1.747a.34.34,0,0,1-.34-.34V344.2a7.91,7.91,0,1,0-15.82,0v1.378a.34.34,0,0,1-.341.34h-.885a.34.34,0,0,1-.341-.34v-8.6a1.425,1.425,0,0,1,1.425-1.425Z",
    transform: "translate(-167.713 -295.38)",
    fill: "#333"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22073",
    "data-name": "Groupe 22073",
    transform: "translate(731.996 565.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_93",
    "data-name": "Groupe 93",
    transform: "translate(0 20.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_67",
    "data-name": "Groupe 67",
    transform: "translate(9.664 6.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33",
    "data-name": "Trac\\xE9 33",
    d: "M1125.8,329.42a1.689,1.689,0,0,1-1.1.375,1.472,1.472,0,0,1-1.6-1.6,1.592,1.592,0,0,1,1.643-1.6,1.463,1.463,0,0,1,1.018.393.29.29,0,0,1-.389.429.943.943,0,0,0-.63-.281,1.065,1.065,0,0,0-1.063,1.063.989.989,0,0,0,1.023,1.063,1.137,1.137,0,0,0,.67-.2v-.549h-.67a.273.273,0,1,1,0-.545h.893a.306.306,0,0,1,.317.264v.951A.358.358,0,0,1,1125.8,329.42Z",
    transform: "translate(-1123.095 -326.562)",
    fill: "#333234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_34",
    "data-name": "Trac\\xE9 34",
    d: "M1156.712,330a.3.3,0,0,1-.594.009v-2.536a.267.267,0,0,1,.268-.273h1.188a.992.992,0,0,1,.42,1.9l.594.723a.3.3,0,1,1-.5.335l-.674-.965h-.7Zm0-1.322h.862a.469.469,0,0,0,0-.938h-.862Z",
    transform: "translate(-1151.762 -327.09)",
    fill: "#333234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_35",
    "data-name": "Trac\\xE9 35",
    d: "M1186.62,329.6a1.559,1.559,0,0,1-1.684-1.607,1.641,1.641,0,0,1,3.282,0A1.557,1.557,0,0,1,1186.62,329.6Zm-.049-2.666a1.058,1.058,0,1,0,1.063,1.058A1.022,1.022,0,0,0,1186.571,326.936Z",
    transform: "translate(-1176.779 -326.356)",
    fill: "#333234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36",
    "data-name": "Trac\\xE9 36",
    d: "M1222.812,327.4a.293.293,0,1,1,.585,0v1.616a1.35,1.35,0,0,1-2.693,0V327.4a.293.293,0,1,1,.585,0v1.616c0,.88,1.523.933,1.523,0Z",
    transform: "translate(-1207.829 -326.991)",
    fill: "#333234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_37",
    "data-name": "Trac\\xE9 37",
    d: "M1252.64,327.206a.307.307,0,0,1,.3-.308h1.032a1.116,1.116,0,0,1,0,2.233h-.746v.59a.281.281,0,0,1-.286.308.3.3,0,0,1-.3-.308Zm.59.254v1.112h.746a.556.556,0,0,0,0-1.112Z",
    transform: "translate(-1235.553 -326.827)",
    fill: "#333234"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_92",
    "data-name": "Groupe 92",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_70",
    "data-name": "Groupe 70",
    transform: "translate(7.711 0.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_69",
    "data-name": "Groupe 69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_68",
    "data-name": "Groupe 68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_38",
    "data-name": "Trac\\xE9 38",
    d: "M1113.282,282.965h-1.6l-.654-.924h-2.743l.386-.879h1.734l-1.8-2.543h1.63Z",
    transform: "translate(-1108.284 -278.62)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_73",
    "data-name": "Groupe 73",
    transform: "translate(11.22 0.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_72",
    "data-name": "Groupe 72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_71",
    "data-name": "Groupe 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_39",
    "data-name": "Trac\\xE9 39",
    d: "M1139.529,282.9h-1.57l-1.179-1.665.205-.026a1.777,1.777,0,0,0,.928-.373.675.675,0,0,0,.262-.492c0-.433-.573-.818-1.306-.876-.066-.005-.134-.01-.2-.01s-1.014,0-1.055,0l-.066,0-.04-.054-.613-.856.238,0h1.536c1.559,0,2.827.806,2.827,1.8a1.571,1.571,0,0,1-.853,1.288Z",
    transform: "translate(-1134.892 -278.551)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_76",
    "data-name": "Groupe 76",
    transform: "translate(23.408 0.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_75",
    "data-name": "Groupe 75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_74",
    "data-name": "Groupe 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_40",
    "data-name": "Trac\\xE9 40",
    d: "M1228.791,279.579h-1.5v-1h1.5Z",
    transform: "translate(-1227.292 -278.584)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_79",
    "data-name": "Groupe 79",
    transform: "translate(16.751 0.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_78",
    "data-name": "Groupe 78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_77",
    "data-name": "Groupe 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_41",
    "data-name": "Trac\\xE9 41",
    d: "M1182.256,282.937H1180.8l-2.586-2.64v2.64h-1.4v-4.353h1.411l2.627,2.7v-2.7h1.4Z",
    transform: "translate(-1176.818 -278.584)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_82",
    "data-name": "Groupe 82",
    transform: "translate(23.408 1.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_81",
    "data-name": "Groupe 81"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_80",
    "data-name": "Groupe 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_42",
    "data-name": "Trac\\xE9 42",
    d: "M1228.791,293.294h-1.5v-2.779h1.5Z",
    transform: "translate(-1227.292 -290.515)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_85",
    "data-name": "Groupe 85",
    transform: "translate(26.022 0.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_84",
    "data-name": "Groupe 84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_83",
    "data-name": "Groupe 83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_43",
    "data-name": "Trac\\xE9 43",
    d: "M1252.546,282.937h-1.4V280.3l-2.585,2.64h-1.454v-4.353h1.4v2.7l2.628-2.7h1.413Z",
    transform: "translate(-1247.105 -278.584)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_88",
    "data-name": "Groupe 88",
    transform: "translate(32.485 0.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_87",
    "data-name": "Groupe 87"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_86",
    "data-name": "Groupe 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_44",
    "data-name": "Trac\\xE9 44",
    d: "M1299.558,282.5a5.514,5.514,0,0,1-1.842-.281,2.527,2.527,0,0,1-1.2-.817,1.9,1.9,0,0,1-.406-1.17,1.835,1.835,0,0,1,.454-1.22,2.825,2.825,0,0,1,1.309-.805,5.243,5.243,0,0,1,1.614-.213,4.713,4.713,0,0,1,1.964.336,1.705,1.705,0,0,1,.918.9l.058.15-1.5.175-.039-.079a.923.923,0,0,0-.472-.419,2.211,2.211,0,0,0-.931-.173,2.384,2.384,0,0,0-1.349.338,1.1,1.1,0,0,0-.48.972,1.208,1.208,0,0,0,.491,1.05,2.286,2.286,0,0,0,1.336.358,3.484,3.484,0,0,0,.83-.1,3.737,3.737,0,0,0,.666-.223v-.391h-1.543v-.881h3.041v1.806l-.061.036a4.6,4.6,0,0,1-1.223.452A6.847,6.847,0,0,1,1299.558,282.5Z",
    transform: "translate(-1296.109 -277.996)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_91",
    "data-name": "Groupe 91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_90",
    "data-name": "Groupe 90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_89",
    "data-name": "Groupe 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_45",
    "data-name": "Trac\\xE9 45",
    d: "M1055.187,280.51h-1.846l.006-2.694-1.714,2.694h-1.8l0-1.951,1.491-2.765,0,2.9,1.746-2.526h1.769l0,2.426,1.326-2.426h1.474l-.206.274Z",
    transform: "translate(-1049.826 -275.794)",
    fill: "#333234"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_98",
    "data-name": "Groupe 98",
    transform: "translate(4.765 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_97",
    "data-name": "Groupe 97",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_94",
    "data-name": "Groupe 94",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_46",
    "data-name": "Trac\\xE9 46",
    d: "M1094.8,122.641c-.664-1.379-1-1.467-1.992-1.467h-6.86s8.12,14.262,8.6,14.926c.638.884,1.293.658,1.487.393.356-.493,1.753-2.986,2.528-4.378a2.1,2.1,0,0,0,.031-2.424C1098.261,128.949,1095.465,124.02,1094.8,122.641Z",
    transform: "translate(-1085.95 -121.174)",
    fill: "#b70715"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_95",
    "data-name": "Groupe 95",
    transform: "translate(10.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_47",
    "data-name": "Trac\\xE9 47",
    d: "M1175.23,121.166s-4.312,0-5.754,0c-1.6,0-1.849.685-1.36,1.69.658,1.354,7.044,12.166,7.854,13.327.593.848,1.287.839,1.619.307s1.879-3.73,2.3-4.522a2.034,2.034,0,0,0-.01-2.013C1179.376,128.957,1175.23,121.166,1175.23,121.166Z",
    transform: "translate(-1167.891 -121.164)",
    fill: "#b70715"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_96",
    "data-name": "Groupe 96",
    transform: "translate(20.698 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_48",
    "data-name": "Trac\\xE9 48",
    d: "M1244.011,121.174c-1.329,0-1.284.49-.925,1.149.372.686,2.409,3.883,2.974,4.894.609,1.089,1.266,1.4,1.673.73.514-.847,3.764-6.774,3.764-6.774Z",
    transform: "translate(-1242.87 -121.174)",
    fill: "#b70715"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamionPl);
export default __webpack_public_path__ + "static/media/camionPL.300874230f8d33ea4adc991b9610cef8.svg";
export { ForwardRef as ReactComponent };